import { collection, getDocs, limit, query, where } from 'firebase/firestore';

import { getFirestore } from './firebase-service';

export interface UserDoc {
  userId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  createdAt?: string;
}

export async function fetchAllUsers(): Promise<UserDoc[]> {
  const firestore = getFirestore();
  const snapshot = await getDocs(collection(firestore, 'users'));
  return snapshot.docs.map((doc) => doc.data() as UserDoc);
}

export async function fetchUserById(userId: string): Promise<UserDoc | null> {
  const firestore = getFirestore();
  const q = query(collection(firestore, 'users'), where('userId', '==', userId), limit(1));
  const snapshot = await getDocs(q);
  return (snapshot.docs[0]?.data() as UserDoc | undefined) ?? null;
}
